// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__335_3","newExpiryDate":"styles_newExpiryDate__yXBnd","footer":"styles_footer__3CUFm"};